import { get } from 'lodash';
import { formatSortCode } from '../../utils/accountUtils';
import { getAddressFormat } from '../../payees/states/addPayeeSuccess/selectors';
import { TYPE_IFT_PAYEE, TYPE_DOMESTIC_PAYEE, payeeTypes } from '../../config';

export const getSelectedPayee = (state) => {
	const {
		managePayee: { selectedPayee },
	} = state;
	const { to_account = {}, display_name, reference, type, address, bank, reference_high_value } = selectedPayee;
	const { iban, name, bic, clearing_code, account_number, sort_code } = to_account;
	switch (type) {
		case 'international':
			return {
				name,
				displayName: display_name,
				payeeAddress: getAddressFormat(address),
				iban,
				accountNumber: account_number,
				bic,
				bankAddress: bank && getAddressFormat(bank.address),
				reasonForPayment: reference_high_value,
				clearingCode: clearing_code,
			};
		case 'chaps':
			return {
				name,
				displayName: display_name,
				sortCode: formatSortCode(sort_code),
				accountNumber: account_number,
				chapsReference: reference_high_value,
				reference,
				payeeAddress: getAddressFormat(address),
			};
		default:
			return {
				name,
				displayName: display_name,
				sortCode: formatSortCode(sort_code),
				accountNumber: account_number,
				reference,
			};
	}
};

export const getSelectedPayeeDetails = (state) => state.managePayee.selectedPayee || {};

export const getSelectedPayeeId = ({ managePayee: { selectedPayee } }) => selectedPayee.id;

export const getSourceAccountId = (state) => {
	const { managePayee } = state;

	return get(managePayee, 'selectedPayee.account.id', '');
};
export const getSelectedPayeeName = (state) => get(state, 'managePayee.selectedPayee.to_account.name', '');
export const getEditPayeeFlag = (state) => state.managePayee.isEditPayeeFlag || false;
export const getPayeeType = (state) => get(state, 'managePayee.payeeType', TYPE_DOMESTIC_PAYEE);
export const isInternationalPayee = (state) =>
	get(state, 'managePayee.selectedPayee.type', '') === payeeTypes.INTERNATIONAL;
export const getAddPayeeId = (state) => {
	const payeeType = getPayeeType(state);
	return payeeType === TYPE_IFT_PAYEE ? 'addInternationalPayee' : 'addPayee';
};

export const getCurrentBatchSize = ({ managePayee: { numberOfItemsInBatch } }) => numberOfItemsInBatch;
export const getIsBatchProcessingProgressOpen = ({ managePayee: { isProcessingBatch } }) => isProcessingBatch;

export const getBatchProcessPercentageComplete = ({
	managePayee: { isProcessingBatch, currentBatchSize, currentBatchProgress },
}) => (isProcessingBatch ? Math.round(100 * (currentBatchProgress / currentBatchSize)) : undefined);

export const getScheduledPaymentsModalContentKey = (state) => {
	const payee = get(state, 'managePayee.selectedPayee', {});
	if (payee.payeeType === payeeTypes.CHAPS) {
		return 'chapsPayeeContent';
	}
	if (payee.payeeType === payeeTypes.INTERNATIONAL) {
		return 'iftPayeeContent';
	}
	return 'domesticPayeeContent';
};

export const getAccountNameServicesError = (state) => get(state, 'api.accountNameServicesError');

export const getIsCOPEdit = (state) => get(state, 'managePayee.isCOPEdit', false);
